import { createFileRoute } from '@tanstack/react-router';
import { TrackingPreferencesPage } from '../../features/tracking';

export const Route = createFileRoute('/portal/tracking/preferences')({ component: TrackingPreferencesPage });
